function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F2D349",
  width: "14",
  height: "14",
  rx: "1.556"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.808 3.025a1.678 1.678 0 110 3.356 1.678 1.678 0 010-3.356zm0 .683a.995.995 0 10.002 1.99.995.995 0 00-.002-1.99zM6.808 6.803c-1.665 0-3.015 1.494-3.015 3.325a.342.342 0 10.684 0c0-1.459 1.049-2.64 2.33-2.64 1.283 0 2.331 1.181 2.331 2.64a.342.342 0 10.684 0c0-1.831-1.35-3.325-3.014-3.325z"
})))));